export default {
  delete: {
    title: 'Note',
    content: 'Do you confirm to delete ',
  },
  indexTable: {
    date: 'Date',
    id: 'Id',
    name: 'Name',
    size: 'Size',
    status: 'Status',
    loadingStatus: 'Loading Status',
    conditionSelected: 'Settings',
    operation: 'Delete History',
    delete: 'Delete',
    batchDeletion: 'Batch Delete',
  },
  modal: {
    title: 'Shops under maintenance',
    text: 'The shops you previously selected include below shops that are currently under maintenance, do you still proceed to download?',
    allDel: 'Remove',
    shop: 'Shop',
    action: 'Action',
    del: 'Delete',
  },
};
